// Shared vocabulary + hint painting for the five MemberOfferAcceptor form panels.
//
// The panels are SIBLINGS, not a hierarchy — each owns its own elements, listeners
// and render (see accept_form.js et al). This module holds only the two things that
// would otherwise drift: the markup's BEM vocabulary (all five panels are one
// `.member_offer_acceptor__form` block with the same parts) and the auth-status hint
// dance, which the four auth panels each need and the accept panel deliberately does
// not (it paints its own endpoint-response message into the hint slot instead).

export const MOA_FORM_BASE_HTML_CLASS = "member_offer_acceptor__form";

export const MoaFormAnatomy = {
  baseHtmlClass: MOA_FORM_BASE_HTML_CLASS,

  titleSelector: ".member_offer_acceptor__form__title",
  hintSelector: ".member_offer_acceptor__form__hint",
  backButtonSelector: ".member_offer_acceptor__foot__item--back button",
};

const HINT_TONES = ["info", "error", "busy"];

// Paints the machine-wide authStatus into a panel's hint slot with its tone modifier
// (`__hint--info/--error/--busy`), reverting to the server-rendered default copy when
// there's no status. authStatus is one-at-a-time, so only the active panel's hint is
// seen; inactive panels paint it harmlessly.
export function renderStatusHint(hintEl, status, defaultHint) {
  if (!hintEl) return;

  HINT_TONES.forEach((tone) => hintEl.classList.remove(`${MOA_FORM_BASE_HTML_CLASS}__hint--${tone}`));

  if (status && status.text) {
    hintEl.textContent = status.text;
    if (status.tone) hintEl.classList.add(`${MOA_FORM_BASE_HTML_CLASS}__hint--${status.tone}`);
  } else {
    hintEl.textContent = defaultHint;
  }
}
